// This legacy endpoint reads Mongo orders; a V2-only order has a UUID instead.
export const isMongoOrderId = (orderId: unknown): orderId is string =>
  typeof orderId === 'string' && /^[a-f\d]{24}$/i.test(orderId);
